module.exports = __webpack_public_path__ + "JP.png?5702fe26a3cffc39f2741aa03c3a06f9";